<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="servicos-view">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <div class="page-text" v-if="(item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '')">
        <div class="auto-container">
          <div class="text-subtitulo w-full" v-html="item.subtitulo"></div>
        </div>
      </div>
      <div :class="'servicos w-full ' + (item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '' ? 'pt-0' : '')">
        <div class="outer-container">
          <div class="servicos-list">
            <div v-if="(servicos.loaded && servicos.list.length > 0)" class="flex flex-wrap">
              <ListItemServico v-for="(forItem, forIndex) in servicos.list" :key="forIndex" :itemIndex="forIndex" :item="forItem" />
            </div>
          </div>
        </div>
      </div>
      <BannerContactos tipo="2" />
    </div>
  </div>
</template>

<script>
import ListItemServico from '@/components/ListItemServico.vue';
import BannerContactos from '@/components/BannerContactos.vue';
export default {
  components: {
    ListItemServico,
    BannerContactos
  },
  data() {
    return {
      loaded: false,
      item: {},
      servicos: {
        loaded: false,
        list: []
      }
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      this.fc_fetch({ endpoint: 'Servicos/', method: 'GET', success: this.mt_loadData_success, error: () => { this.fc_goRoute('home'); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.list != null) {
        this.servicos.list = response.list;
      }
      this.servicos.loaded = true;
      this.loaded = true;
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ServicosPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
.servicos {
  padding-bottom: 65px;
}
.servicos {
  position: relative;
  padding: 90px 0 70px;
}
.servicos-list {
  margin-right: -15px;
  margin-left: -15px;
}
</style>
